import lottie from "lottie-web";
import { useEffect, useRef } from "react";

interface LottieViewProps {
    animationData: unknown; // The imported .json animation
    loop?: boolean;
    className?: string; // Size it with this, e.g. "h-64 w-64"
}

// Plays a Lottie animation inside a box that fills the size you give it
const LottieView = ({ animationData, loop = false, className }: LottieViewProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const animation = lottie.loadAnimation({
            container,
            renderer: "svg",
            loop,
            autoplay: true,
            animationData
        });

        // Stops the animation and frees its DOM when the components unmounts or the props change
        return () => animation.destroy();
    }, [animationData, loop]);

    // Purely decorative, so screen readers skip it
    return <div ref={containerRef} className={className} aria-hidden="true" />;
};

export default LottieView;